import styled from 'styled-components';
import { BaseInputRoot } from '../../common/BaseInput/BaseInput.styled';
// styled-components.
// -----------------------------------------------------------------------------
export const TextFieldRoot = styled.input `
  ${BaseInputRoot}
`;
export const TextFieldWrapper = styled.div `
  position: relative;

  .btn-eye {
    background: transparent;
    border: none;
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translate(0, -50%);
  }
`;
//# sourceMappingURL=TextField.styled.js.map